var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center p-6 border-1 border-critical bg-critical bg-opacity-10 text-critical w-full"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }